import { ROUTE_ALIASES } from '@/routing/routesAliases';
import { WEB_PARTITION } from '@/types';

export const getWebPartition = (pathname: string): WEB_PARTITION => {
  if (pathname.startsWith(ROUTE_ALIASES.MESSAGES)) {
    return WEB_PARTITION.MESSAGES;
  }

  if (pathname.startsWith(ROUTE_ALIASES.FORMS)) {
    return WEB_PARTITION.FORMS;
  }

  if (pathname.startsWith(ROUTE_ALIASES.MINISTRIES)) {
    return WEB_PARTITION.MINISTRIES;
  }

  return WEB_PARTITION.MPA;
};
